<p-toast position="top-right"></p-toast>
<div class="login-body">
  <div class="signin_btn">
    <button pButton type="submit" icon="ui-icon-person" routerLink="/login" [label]='setLabel("signInLabel")' style="width: 100%"
      icon="ui-icon-person"></button>
  </div>
  <div class="card login-panel ui-fluid">

    <p-tabView>
      <!-- company tab -->
      <!-- [selected]="activeIndex==0" -->
      <p-tabPanel [header]='setLabel("companyHeaderLabel")' [disabled]="true" *ngIf="activeIndex == 0">
        <form [formGroup]="companyForm" #companyformDir="ngForm">
          <div [hidden]="companyformDir.submitted">
            <div class="ui-g">
              <div class="ui-g-12">
                <img src="assets/layout/images/gym.png">
                <br>
                <h2>{{setLabel("companyInformationLabel")}}</h2>
              </div>

              <div class="ui-g-12">
                <div class="bannerImgDiv">
                  <img class="bannerImg" [src]="!uploadProfile ?
                  (company.bannerImage ? config.Server + config.companyImagePath + company.bannerImage : 'assets/layout/images/logoCompany.png')
                : company.bannerImage" />
                </div>
                <div class="company-next-row upload-logo-row">
                  <div class="ui-g-4"></div>
                  <div class="ui-g-4">
                    <a (click)="captureImageDialogShow('Upload')" class="captureImageDialogShow">
                      <span class="ui-button-text ui-c">
                        <i class="fa fa-upload" aria-hidden="true"></i> &nbsp;{{setLabel("uploadLogoLabel")}}
                      </span>
                    </a>
                    <h3 class="companyLogo">{{setLabel("companylogoLabel")}}</h3>
                  </div>
                  <div class="ui-g-4"></div>
                </div>
              </div>

              <div class="ui-g-12 register-fields">
                  <div class="inputDiv">
                    <span class="p-float-label md-inputfield-noAnimation">
                      <input type="text" name="name" maxlength="100" required id="name" formControlName="name"
                        autocomplete="off" pInputText>
                      <div *ngIf="name.invalid && (name.dirty || name.touched)" class="input-error">
                        <div *ngIf="name.errors.required">
                          {{setLabel("companyNamerequiredLabel")}}
                        </div>


                        <!-- <div *ngIf="name.errors.pattern" style="text-align: end; color: red; font-size: small;">
                          Company Name must be in number.
                        </div> -->
                      </div>
                      <label>{{setLabel("companyNameLabel")}}
                        <span class="asterisk">*</span>
                      </label>
                    </span>
                  </div>

                  <div class="inputDiv">
                    <span class="p-float-label md-inputfield-noAnimation">
                      <input type="text" name="type" maxlength="100" required id="type" formControlName="type"
                        autocomplete="off" pInputText>
                      <div *ngIf="type.invalid && (type.dirty || type.touched)" class="input-error">
                        <div *ngIf="type.errors.required">
                          {{setLabel("companyTypeRequiredLabel")}}
                        </div>
                      </div>
                      <label>{{setLabel("companyTypeLabel")}}
                        <span class="asterisk">*</span>
                      </label>
                    </span>
                  </div>

                  <div class="inputDiv">
                    <span class="p-float-label md-inputfield-noAnimation">
                      <input type="text" name="contactPersonName" maxlength="100" formControlName="contactPerson"
                        id="contactPerson" autocomplete="off" pInputText required>
                      <div *ngIf="contactPerson.invalid && (contactPerson.dirty || contactPerson.touched)"
                        class="input-error">
                        <div *ngIf="contactPerson.errors.required">
                          {{setLabel("contactPersonRequiredLabel")}}
                        </div>
                      </div>
                      <label>{{setLabel("contactPersonLabel")}}
                        <span class="asterisk">*</span>
                      </label>
                    </span>
                  </div>
                  <div class="inputDiv phone-row">
                    <span class="p-float-label md-inputfield-noAnimation phone-field">
                      <app-phone-input
                        id="phone"
                        formControlName="phone"
                        [placeholder]="setLabel('contactNoLabel')"
                        [required]="true">
                      </app-phone-input>
                      <label>{{setLabel("contactNoLabel")}}
                        <span class="asterisk">*</span>
                      </label>
                    </span>
                  </div>
                  <div class="inputDiv">
                    <span class="p-float-label md-inputfield-noAnimation">
                      <input type="email" name="contactPersonEmail" formControlName="contactPersonEmail"
                        id="contactPersonEmail" maxlength="256" autocomplete="off" pInputText required>
                      <div
                        *ngIf="contactPersonEmail.invalid && (contactPersonEmail.dirty || contactPersonEmail.touched)"
                        class="input-error">
                        <div *ngIf="contactPersonEmail.errors.pattern">
                          {{setLabel("emailCorrectlyLabel")}}
                        </div>
                        <div *ngIf="contactPersonEmail.errors.required">
                          {{setLabel("emailRequiredLabel")}}
                        </div>

                      </div>
                      <label>{{setLabel("contactEmailLabel")}}
                        <span class="asterisk">*</span>
                      </label>
                    </span>
                  </div>
                  <div class="inputDiv">
                    <span class="p-float-label md-inputfield-noAnimation">
                      <input type="text" name="address" maxlength="256" id="address" formControlName="address"
                        autocomplete="off" pInputText>
                      <label>{{setLabel("addressLabel")}}</label>
                    </span>
                  </div>

                  <div class="inputDiv">
                    <span class="p-float-label md-inputfield-noAnimation">
                      <input type="text" name="smsUsername" maxlength="12" id="smsUsername"
                        formControlName="smsUsername" autocomplete="off" pInputText>
                      <div *ngIf="smsUsername.invalid && (smsUsername.dirty || smsUsername.touched  )"
                        class="input-error">
                        <div *ngIf="smsUsername.errors.pattern">
                          {{setLabel("validUsernameContactLabel")}} {{errorExempleNumber}}
                        </div>
                      </div>
                      <label>{{setLabel("sMSUsernameLabel")}}

                      </label>
                    </span>
                  </div>

                  <div class="inputDiv">
                    <span class="p-float-label md-inputfield-noAnimation">
                      <input type="password" name="smsPassword" maxlength="100" id="smsPassword"
                        formControlName="smsPassword" autocomplete="off" pInputText>
                      <label>{{setLabel("sMSPasswordLabel")}}

                      </label>
                    </span>
                  </div>

                  <div class="inputDiv">
                    <span class="p-float-label md-inputfield-noAnimation">
                      <input type="text" name="smsSender" maxlength="100" id="smsSender" formControlName="smsSender"
                        autocomplete="off" pInputText>
                      <label>{{setLabel("sMSSenderLabel")}}

                      </label>
                    </span>
                  </div>

                  <div class="inputDiv">
                    <span class="p-float-label md-inputfield-noAnimation">
                      <input type="text" name="whatsappApiKey" maxlength="100" id="whatsappApiKey"
                        formControlName="whatsappApiKey" autocomplete="off" pInputText>
                      <label>{{setLabel("whatsappAPIKeyLabel")}}

                      </label>
                    </span>
                  </div>

                  <div class="inputDiv">
                    <span class="p-float-label md-inputfield-noAnimation">
                      <input type="text" name="websiteUrl" maxlength="2048" id="websiteUrl" formControlName="websiteUrl"
                        autocomplete="off" pInputText>
                      <label>{{setLabel("websiteUrlLabel")}}</label>
                    </span>
                  </div>



                  <!-- style="height:60px; padding: 0.5em;" -->



              </div>

              <!-- <div class="ui-g-12">
                <div class="ui-g-4">
                  <span class="md-inputfield">
                    <input type="text" name="name" required id="name" formControlName="name" autocomplete="off"
                      pInputText>
                    <div *ngIf="name.invalid && (name.dirty || name.touched)" class="input-error">
                      <div *ngIf="name.errors.required" style="text-align: end; color: red; font-size: small;">
                        Company Name is required.
                      </div>
                      <div *ngIf="name.errors.pattern" style="text-align: end; color: red; font-size: small;">
                        Company Name must be in number.
                      </div>
                    </div>
                    <label>Company Name</label>
                  </span>
                </div>
                <div class="ui-g-4">
                  <span class="md-inputfield">
                    <input type="text" name="type" required id="type" formControlName="type" autocomplete="off"
                      pInputText>
                    <div *ngIf="type.invalid && (type.dirty || type.touched)" class="input-error">
                      <div *ngIf="type.errors.required" style="text-align: end; color: red; font-size: small;">
                        Company Type is required.
                      </div>
                    </div>
                    <label>Company Type</label>
                  </span>
                </div>

                <div class="ui-g-4">
                  <span class="md-inputfield">
                    <input type="text" name="address" id="address" formControlName="address" autocomplete="off"
                      pInputText>
                    <label>Address</label>
                  </span>
                </div>

              </div>

              <div class="ui-g-12">
                <div class="ui-g-4">
                  <span class="md-inputfield">
                    <input type="text" name="websiteUrl" id="websiteUrl" formControlName="websiteUrl" autocomplete="off"
                      pInputText>
                    <label>Website Url</label>
                  </span>
                </div>
                <div class="ui-g-4">
                  <span class="md-inputfield">
                    <input type="text" name="phone" formControlName="phone" id="phone" autocomplete="off" pInputText
                      required>
                    <div *ngIf="phone.invalid && (phone.dirty || phone.touched)" class="input-error">
                      <div *ngIf="phone.errors.required" style="text-align: end; color: red; font-size: small;">
                        Contact No is required.
                      </div>
                      <div *ngIf="phone.errors.pattern" style="text-align: end; color: red; font-size: small;">
                        Please enter valid Contact No, e.g. {{errorExempleNumber}}
                      </div>
                    </div>
                    <label>Contact No</label>
                  </span>
                </div>
              </div>

              <div class="ui-g-12">
                <div class="ui-g-4">
                  <span class="md-inputfield">
                    <input type="text" name="contactPerson" formControlName="contactPerson" id="contactPerson"
                      autocomplete="off" pInputText required>
                    <div *ngIf="contactPerson.invalid && (contactPerson.dirty || contactPerson.touched)"
                      class="input-error">
                      <div *ngIf="contactPerson.errors.required" style="text-align: end; color: red; font-size: small;">
                        Contact Person is required.
                      </div>
                    </div>
                    <label>Contact Person</label>
                  </span>
                </div>
                <div class="ui-g-4">
                  <span class="md-inputfield">
                    <input type="text" name="contactPersonEmail" pattern="" formControlName="contactPersonEmail"
                      id="contactPersonEmail" autocomplete="off" pInputText required>
                    <div *ngIf="contactPersonEmail.invalid && (contactPersonEmail.dirty || contactPersonEmail.touched)"
                      class="input-error">
                      <div *ngIf="contactPersonEmail.errors.pattern"
                        style="text-align: end; color: red; font-size: small;">
                        Email Pattern is wrong.
                      </div>
                      <div *ngIf="contactPersonEmail.errors.required"
                        style="text-align: end; color: red; font-size: small;">
                        Email is required.
                      </div>
                    </div>
                    <label>Contact Email</label>
                  </span>
                </div>
                <div class="ui-g-4">
                  <h3>Company logo</h3>


                  <a (click)="captureImageDialogShow('Upload')" class="" style="width: 100%;
                                    overflow: hidden;
                                    background-color: #2f4050;
                                    color: #ffffff;
                                    font-size: 1em;
                                    height: 2.143em;
                                    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif';
                                    padding: 9px 6em;
                                    border: 0 none;
                                    transition: background-color 0.3s;">
                    <span class="ui-button-text ui-c">
                      <i class="fa fa-upload" aria-hidden="true"></i> &nbsp;Upload Logo
                    </span>
                  </a>

                </div>
              </div> -->

              <div class="ui-g-12 company-next-row">
                <div class="ui-g-4"></div>
                <div class="ui-g-4">
                  <button class=" p-widget" type="button" pButton id="companyNextButton" (click)="nextform()"
                  [label]='setLabel("nextLabel")' [disabled]="companyForm.invalid" style="width: 100%" icon="ui-icon-person"></button>

                  <!-- <a pButton id="companyNextButton" type="submit" (click)="nextform()"
                    [disabled]="companyForm.invalid" style="width: 100%" icon="ui-icon-person">Next</a> -->
                </div>
                <div class="ui-g-4"></div>
              </div>

            </div>
          </div>
        </form>

      </p-tabPanel>

      <!-- branch tab -->
      <!-- [selected]="indextab==1" -->
      <p-tabPanel [header]='setLabel("branchHeaderLabel")' [disabled]="true" *ngIf="activeIndex == 1">
        <form [formGroup]="branchForm" #branchformDir="ngForm">
          <div [hidden]="branchformDir.submitted">
            <div class="ui-g">
              <div class="ui-g-12">
                <img src="assets/layout/images/gym.png">
                <br>
                <h2>{{setLabel("branchInformationLabel")}}</h2>
              </div>
              <div class="ui-g-12 register-fields">
                <div class="inputDiv">
                  <span class="p-float-label md-inputfield-noAnimation">
                    <input type="text" name="branchname" maxlength="100" id="branchname" formControlName="branchname"
                      required autocomplete="off" pInputText>
                    <div *ngIf="branchname.invalid && (branchname.dirty || branchname.touched)" class="input-error">
                      <div *ngIf="branchname.errors.required">
                        {{setLabel("branchNameRequiredLabel")}}
                      </div>
                    </div>
                    <label>{{setLabel("branchNameLabel")}}
                      <span class="asterisk">*</span>
                    </label>
                  </span>
                </div>
                <div class="inputDiv">
                  <span class="p-float-label md-inputfield-noAnimation">
                    <input type="text" name="domainname" id="domainname" formControlName="domainname" required
                      autocomplete="off" pInputText>
                    <div *ngIf="domainname.invalid && (domainname.dirty || domainname.touched)" class="input-error">
                      <div *ngIf="domainname.errors.required">
                        {{setLabel("domainNameRequiredLabel")}}
                      </div>
                    </div>
                    <label>{{setLabel("domainNameLabel")}}
                      <span class="asterisk">*</span>
                    </label>
                  </span>
                </div>
                <div class="inputDiv">
                  <span class="p-float-label md-inputfield-noAnimation">
                    <input type="text" name="branchaddress" formControlName="branchaddress" id="branchaddress"
                      autocomplete="off" pInputText maxlength="256" required>
                    <div *ngIf="branchaddress.invalid && (branchaddress.dirty || branchaddress.touched)"
                      class="input-error">
                      <div *ngIf="branchaddress.errors.required">
                        {{setLabel("branchAddressRequiredLabel")}}
                      </div>
                    </div>
                    <label>{{setLabel("addressLabel")}}
                      <span class="asterisk">*</span>
                    </label>
                  </span>
                </div>
                <div class="inputDiv">
                  <span class="p-float-label md-inputfield-noAnimation phone-field">
                    <app-phone-input
                      id="branchphone"
                      formControlName="branchphone"
                      [placeholder]="setLabel('contactNoLabel')"
                      [required]="true">
                    </app-phone-input>
                    <label>{{setLabel("contactNoLabel")}}
                      <span class="asterisk">*</span>
                    </label>
                  </span>
                </div>
                <div class="inputDiv">
                  <span class="p-float-label md-inputfield-noAnimation">
                    <input type="email" name="branchcontactPerson" maxlength="100" id="branchcontactPerson"
                      formControlName="branchcontactPerson" autocomplete="off" pInputText>
                    <label>{{setLabel("contactPersonLabel")}}</label>
                  </span>
                </div>
                <div class="inputDiv">
                  <span class="p-float-label md-inputfield-noAnimation">
                    <input type="text" name="branchcontactPersonEmail" maxlength="256" id="branchcontactPersonEmail"
                      formControlName="branchcontactPersonEmail" autocomplete="off" pInputText required>
                    <div
                      *ngIf="branchcontactPersonEmail.invalid && (branchcontactPersonEmail.dirty || branchcontactPersonEmail.touched)"
                      class="input-error">
                      <div *ngIf="branchcontactPersonEmail.errors.pattern">
                        {{setLabel("emailCorrectlyLabel")}}
                      </div>
                      <div *ngIf="branchcontactPersonEmail.errors.required">
                        {{setLabel("emailRequiredLabel")}}
                      </div>
                    </div>
                    <label>{{setLabel("contactEmailLabel")}}</label>
                  </span>
                </div>
                <div class="inputDiv">
                  <span class="p-float-label md-inputfield-noAnimation">
                    <input type="number" name="branchvisitorFee" maxlength="100" id="branchvisitorFee"
                      formControlName="branchvisitorFee" autocomplete="off" pInputText pattern="[0-9]*">
                    <label>{{setLabel("visitorFeeLabel")}}</label>
                  </span>
                </div>
                <div class="inputDiv">
                  <span class="p-float-label md-inputfield-noAnimation phone-field">
                    <app-phone-input
                      id="branchwhatsapp"
                      formControlName="branchwhatsapp"
                      [placeholder]="setLabel('whatsAppNoLabel')"
                      [required]="true">
                    </app-phone-input>
                    <label>{{setLabel("whatsAppNoLabel")}}
                      <span class="asterisk">*</span>
                    </label>
                  </span>
                </div>
                <div class="inputDiv">
                  <span class="p-float-label md-inputfield-noAnimation phone-field">
                    <app-phone-input
                      id="branchfeewhatsapp"
                      formControlName="branchfeewhatsapp"
                      [placeholder]="setLabel('feeWhatsAppNoLabel')"
                      [required]="false">
                    </app-phone-input>
                    <label>{{setLabel("feeWhatsAppNoLabel")}}</label>
                  </span>
                </div>
                <div class="inputDiv">
                  <span class="p-float-label md-inputfield-noAnimation phone-field">
                    <app-phone-input
                      id="branchvisitorwhatsapp"
                      formControlName="branchvisitorwhatsapp"
                      [placeholder]="setLabel('visitorWhatsAppNoLabel')"
                      [required]="false">
                    </app-phone-input>
                    <label>{{setLabel("visitorWhatsAppNoLabel")}}</label>
                  </span>
                </div>
                <div class="inputDiv">
                  <span class="p-float-label md-inputfield-noAnimation phone-field">
                    <app-phone-input
                      id="branchregistrationwhatsapp"
                      formControlName="branchregistrationwhatsapp"
                      [placeholder]="setLabel('registrationWhatsAppNoLabel')"
                      [required]="false">
                    </app-phone-input>
                    <label>{{setLabel("registrationWhatsAppNoLabel")}}</label>
                  </span>
                </div>


                <div class="inputDiv">
                  <span class="p-float-label md-inputfield-noAnimation">
                    <select name="gymPackage" id="gymPackage" formControlName="gymPackage" required>
                      <option value="standard" selected>Standard</option>
                      <option value="premium">Premium</option>
                      <option value="enterprise">Enterprise</option>
                    </select>
                    <label>Gym Package
                      <span class="asterisk">*</span>
                    </label>
                  </span>
                </div>
                <div class="inputDiv">
                  <span class="p-float-label md-inputfield-noAnimation">
                    <select name="isWhatsappEnabled" id="isWhatsappEnabled" formControlName="isWhatsappEnabled"
                      required>
                      <option [value]='setLabel("nOValueLabel")'>{{setLabel("nOValueLabel")}}</option>
                      <option [value]='setLabel("yESValueLabel")' selected>{{setLabel("yESValueLabel")}}</option>
                    </select>
                    <label>{{setLabel("whatsappAccountLabel")}}</label>
                  </span>
                </div>

                <div class="inputDiv">
                  <span class="p-float-label md-inputfield-noAnimation">
                    <select name="isSmsEnabled" id="isSmsEnabled" formControlName="isSmsEnabled" required>
                      <option [value]='setLabel("nOValueLabel")'>{{setLabel("nOValueLabel")}}</option>
                      <option [value]='setLabel("yESValueLabel")' selected>{{setLabel("yESValueLabel")}}</option>
                    </select>
                    <label>{{setLabel("sMSAccountLabel")}}</label>
                  </span>
                </div>

                <div class="inputDiv">
                  <span class="p-float-label md-inputfield-noAnimation">
                    <select name="lockDefaulterOnACT" id="lockDefaulterOnACT" formControlName="lockDefaulterOnACT"
                      required>
                      <option [value]='setLabel("falseValueLabel")'>{{setLabel("nOValueLabel")}}</option>
                      <option [value]='setLabel("trueValueLabel")' selected>{{setLabel("yESValueLabel")}}</option>
                    </select>
                    <label>{{setLabel("lockDefaulters on ACTLabel")}}</label>
                  </span>
                </div>

              </div>
              <div class="ui-g-12 company-next-row">
                <div class="ui-g-4"></div>
                <div class="ui-g-4">
                  <button class=" p-widget" pButton type="button" id="branchNextButton" (click)="nextform()"
                  [label]='setLabel("nextLabel")' [disabled]="branchForm.invalid" style="width: 100%" icon="ui-icon-person"></button>
                </div>
                <div class="ui-g-4"></div>
              </div>
            </div>
          </div>
        </form>
      </p-tabPanel>

      <!-- User tab -->
      <!-- [selected]="indextab==2" -->
      <p-tabPanel [header]='setLabel("userHeaderLabel")' [disabled]="true" *ngIf="activeIndex == 2">
        <form [formGroup]="userForm" #userformDir="ngForm">
          <div [hidden]="userformDir.submitted">
            <div class="ui-g">
              <div class="ui-g-12">
                <img src="assets/layout/images/gym.png">
                <br>
                <h2>{{setLabel("userInformationLabel")}}</h2>
              </div>
              <div class="ui-g-12 register-fields">
                <div class="inputDiv">
                  <span class="p-float-label md-inputfield-noAnimation">
                    <input type="text" name="fullname" id="fullname" maxlength="100" formControlName="fullname" required
                      autocomplete="off" pInputText>
                    <div *ngIf="fullname.invalid && (fullname.dirty || fullname.touched)" class="input-error">
                      <div *ngIf="fullname.errors.required">
                        {{setLabel("nameRequiredLabel")}}
                      </div>
                    </div>
                    <label>{{setLabel("nameLabel")}}</label>
                  </span>
                </div>
                <div class="inputDiv">
                  <span class="p-float-label md-inputfield-noAnimation">
                    <label>{{setLabel("usernameLabel")}}</label>
                    <div class="username-row">
                      <input type="text" name="username" id="username" maxlength="100"
                        formControlName="username" required autocomplete="off" pInputText>
                      <span class="username-domain">{{setLabel("@Label")}}{{userdomain}}</span>
                    </div>
                    <div *ngIf="username.invalid && (username.dirty || username.touched)" class="input-error">
                      <div *ngIf="username.errors.required">
                        {{setLabel("usernameRequiredLabel")}}
                      </div>
                    </div>
                  </span>
                </div>
                <div class="inputDiv">
                  <span class="p-float-label md-inputfield-noAnimation">
                    <input type="text" name="password" id="password" maxlength="20" formControlName="password"
                      autocomplete="off" pInputText>
                    <div *ngIf="password.invalid && (password.dirty || password.touched)" class="input-error">
                      <div *ngIf="password.errors.required">
                        {{setLabel("passwordRequiredLabel")}}
                      </div>
                    </div>
                    <label>{{setLabel("passwordLabel")}}</label>
                  </span>
                </div>
              </div>

              <div style="display: contents;">
                <div class="ui-g-4" style="margin-right: 5vh;"></div>
                <div class="ui-g-4">
                  <div class="card-body">
                    <div #recaptcha></div>
                  </div>
                </div>
              </div>

              <div class="ui-g-12 company-next-row">
                <div class="ui-g-4"></div>
                <div class="ui-g-4">
                  <!-- (click)="verifyReCaptcha()" -->
                  <!-- [disabled]="userForm.invalid || isDisableSignin"  -->
                  <button [disabled]="userForm.invalid || isRegistrationSuccessful" class=" p-widget" pButton type="button" id="registerButton"
                  [label]='setLabel("registerLabel")' style="width: 100%" icon="ui-icon-person" (click)="registerCompany()"></button>
                </div>
                <div class="ui-g-4"></div>
              </div>
            </div>
          </div>
        </form>
      </p-tabPanel>

    </p-tabView>
  </div>
  <div *ngIf="dialogVisibility" class="tecfolkLogoDialogFix">
    <p-dialog [header]='setLabel("addGymLogoHeaderLabel")' [(visible)]="dialogVisibility">
      <app-add-logo-size-image [popupType]="addProfileImage" (closeThePopup)="hideAddProfileImage()"
        (outputImage)="handleImagefromNewProfile($event)"></app-add-logo-size-image>
    </p-dialog>
  </div>
</div>

<!-- ALL DONE HERE -->
<!-- NEED TRANSLATION TO AR ALL ON GLOBLE AND SELF -->